import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0
        };
        this.interval = null;
        this.images = [
            process.env.PUBLIC_URL + '/images/slides/stats-elite-data-consulting.png',
            process.env.PUBLIC_URL + '/images/slides/stats-elite-merl-fieldwork.png',
            process.env.PUBLIC_URL + '/images/slides/stats-elite-training.png'
        ];
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState(prev => ({ index: (prev.index + 1) % this.images.length }));
        }, 5000);
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
    }
    render() {
        return (
            <section className="flat-row flat-slider">
                <div
                    style={{
                        position: 'relative',
                        width: '100vw',
                        marginLeft: 'calc(50% - 50vw)',
                        height: '85vh',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={this.images[this.state.index]}
                        alt="Stats Elites"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                        onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/images/logo@2x.png'; }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'linear-gradient(180deg, rgba(8,18,36,0.55) 0%, rgba(8,18,36,0.38) 55%, rgba(8,18,36,0.22) 100%)'
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            color: '#ffffff',
                            padding: '0 24px',
                            width: '100%',
                            maxWidth: '1100px'
                        }}
                    >
                        <h1 style={{ fontSize: 'clamp(2rem, 4.2vw, 3rem)', fontWeight: '800', marginBottom: '0.75rem', lineHeight: 1.2, letterSpacing: '0.2px' }}>
                            Empowering Organizations Through Data-Driven Insights
                        </h1>
                        <p style={{ fontSize: 'clamp(0.95rem, 1.8vw, 1.2rem)', marginBottom: '1.5rem', opacity: 0.93 }}>
                            Expert Consulting and Training in MERL and Statistics
                        </p>
                        <Link to="/services-v1">
                            <button
                                style={{
                                    backgroundImage: 'linear-gradient(90deg, #62B6E8, #8AD2F5)',
                                    color: '#ffffff',
                                    padding: '12px 28px',
                                    border: 'none',
                                    borderRadius: 0,
                                    fontSize: '0.95rem',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center'
                                }}
                                onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; }}
                            >
                                Explore Solutions
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        );
    }
}

export default Slider;
